import React from 'react';
import { Navigate } from 'react-router-dom';
import { getUserRoles } from '../api/axios';

const ProtectedRoute = ({ roles, children }) => {
    const userRoles = getUserRoles();

    // Check if the user has at least one required role
    const hasAccess = roles.some((role) => userRoles.includes(role));

    if (!hasAccess) {
        return <Navigate to="/unauthorized" />;
    }

    return children;
};

export default ProtectedRoute;
